// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background: #121212;
    color: #F1F1F1;
    font: 500 normal 22px/1.3 'Satoshi', sans-serif;
}
.mwg_effect031 {
    padding: 0 0 0 0;
    position: relative;
    overflow-x: hidden;
    overflow-y: visible;
    margin: 0;
    width: 100%;
    max-width: calc(100 * var(--vw));
}
.mwg_effect031 .scroll {
    position: fixed;
    bottom: 2rem;
    left: 2rem;
    z-index: 1000;
    font-weight: 100;
    color: #3d3c3c;
}
.mwg_effect031 .slide {
    height: 100vh;
    position: relative;
    /* box-shadow: 3px 3px 30px rgba(0, 0, 0, 0.14); */
}
.mwg_effect031 .content-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    max-width: calc(100 * var(--vw));
    overflow-x: hidden;
    perspective: calc(250 * var(--vw));
}
.mwg_effect031 .content {
    position: absolute;
    inset: 0;
    transform-style: preserve-3d; /* inherits the perspective from the parent */
    transform-origin: 50% 10%;
    padding: 25px 50px 20px 25px;
    display: flex;
    flex-direction: column;
    gap: 10vh;
    width: 100%;
    max-width: calc(100 * var(--vw));
    box-sizing: border-box;
}
.mwg_effect031 .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15vh; /* Lower position for desktop */
    margin-left: calc(4 * var(--vw)); /* Shift to right for desktop */
    margin-bottom: 4vh;
    position: relative; /* For absolute positioning of SVG */
}
.mwg_effect031 .bottom {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    
}
/* Hide num in desktop */
.mwg_effect031 .num {
    display: none;
}

/* First div: num and image (now first) - image only in desktop */
.mwg_effect031 .bottom > div:first-child {
    display: flex;
    font: 500 normal calc(10.5 * var(--vw)) / 0.9 'Satoshi', sans-serif;
    letter-spacing: -0.06em;
    gap: 25px;
    order: 2; /* Move to right */
    margin-top: -10vh; /* Raise position for desktop */
    margin-right: calc(8 * var(--vw)); /* Shift to left for desktop */
}

.mwg_effect031 .bottom img {
    width: calc(21 * var(--vw)); /* Slightly larger size for desktop */
    max-width: calc(calc(100 * var(--vw)) - 100px);
    border-radius: 0.02em;
    box-sizing: border-box;
}

/* Last div: text and button (now last) - move to left */
.mwg_effect031 .bottom > div:last-child {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-left: calc(4 * var(--vw)); /* Shift to right for desktop */
    margin-right: 60px;
    margin-top: -6vh; /* Higher position for desktop */
    order: 1; /* Move to left */
}

.mwg_effect031 .text {
    width: calc(50 * var(--vw));
    max-width: calc(calc(100 * var(--vw)) - 100px);
    display: flex;
    align-items: flex-start;
    font: 500 normal calc(2.6 * var(--vw)) / 1.4 'Satoshi', sans-serif;
    letter-spacing: -0.03em;
    padding-bottom: 0;
    box-sizing: border-box;
}

.mwg_effect031 .text-note {
    font-size: calc(1.8 * var(--vw));
    font-style: italic;
    opacity: 0.9;
}
.mwg_effect031 .slide-btn {
    display: inline-flex;
    align-items: center;
    gap: 16px;
    padding: 18px 32px;
    border: 1px solid currentColor;
    background: transparent;
    color: currentColor;
    margin-top: 12px;
    font-size: 14px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    cursor: pointer;
    font-family: inherit;
    width: fit-content;
}
.mwg_effect031 .slide-btn span {
    font-size: 18px;
}
.mwg_effect031 .top p {
    font: 500 normal clamp(30px, calc(6.2 * var(--vw)), 72px) / 1 'Satoshi', sans-serif;
    letter-spacing: -0.06em;
    padding-top: 40px;
}
.mwg_effect031 .top svg {
    width: calc(5.7 * var(--vw));
    max-width: 100px;
    height: auto;
    display: block;
    position: absolute; /* Position at top right corner for desktop */
    top: -40px; /* Higher position */
    right: 0;
    margin-top: 0; /* Remove spacing from top */
    margin-right: 20px; /* Add spacing from right */
}

.mwg_effect031 .slide:nth-child(1) .content {
    background: #C4EF7A;
    color: #184739;
} 

.mwg_effect031 .slide:nth-child(4) .content {
    background: #F1F1F1;
    color: #121212;
}
.mwg_effect031 .slide:nth-child(2) .content,
.mwg_effect031 .slide:nth-child(5) .content {
    background: #DEDA8D;
    color: #3D4331;
}
.mwg_effect031 .slide:nth-child(3) .content {
    background: #71CFA3;
    color: #184739;
}

/* ==================== MEDIA QUERIES ==================== */

/* Tablet and below (max-width: 1024px) */
@media (max-width: 1024px) {
  .mwg_effect031 .num {
    display: block;
  }

  .mwg_effect031 .bottom > div:first-child {
    order: 1;
    margin-top: 0; /* Reset for tablet */
    margin-right: 0; /* Reset for tablet */
  }

  .mwg_effect031 .bottom > div:last-child {
    order: 2;
    margin-right: 0;
    margin-left: 60px;
    margin-top: 0; /* Reset for tablet */
  }
  
  .mwg_effect031 .top {
    margin-top: 0; /* Reset for tablet */
    margin-left: 0; /* Reset for tablet */
  }

  .mwg_effect031 .content {
    padding: 20px 40px 40px 20px;
  }

  .mwg_effect031 .text {
    width: calc(40 * var(--vw));
    font-size: calc(1.8 * var(--vw));
  }

  .mwg_effect031 .top p {
    font-size: calc(9 * var(--vw));
    padding-top: 30px;
  }

  .mwg_effect031 .bottom > div:last-child {
    font-size: calc(9 * var(--vw));
  }

  .mwg_effect031 .bottom img {
    width: calc(28 * var(--vw));
  }

  .mwg_effect031 .top svg {
    width: calc(6.5 * var(--vw));
    position: relative; /* Reset for tablet */
    top: auto;
    right: auto;
  }

  .mwg_effect031 .slide-btn {
    padding: 16px 28px;
    font-size: 13px;
  }
}

/* Mobile (max-width: 768px) */
@media (max-width: 768px) {
  .mwg_effect031 .num {
    display: block;
  }

  .mwg_effect031 .bottom > div:first-child {
    order: 1;
  }

  .mwg_effect031 .bottom > div:last-child {
    order: 2;
    margin-right: 0;
  }

  body {
    font-size: 18px;
  }

  .mwg_effect031 .scroll {
    bottom: 1rem;
    left: 1rem;
    font-size: 14px;
  }

  .mwg_effect031 .slide {
    height: auto;
    min-height: 100vh;
  }

  .mwg_effect031 .content-wrapper {
    height: auto !important;
    min-height: 100vh;
  }

  .mwg_effect031 .content {
    padding: 25px 20px 50px 20px;
    justify-content: flex-start !important;
    min-height: 100vh;
    position: relative !important;
  }

  .mwg_effect031 .top {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    margin-top: 0; /* Reset for mobile */
    margin-left: 0; /* Reset for mobile */
  }

  .mwg_effect031 .top p {
    font-size: 48px;
    padding-top: 0;
  }

  .mwg_effect031 .top svg {
    width: 40px;
    position: relative; /* Reset for mobile */
    top: auto;
    right: auto;
  }

  .mwg_effect031 .bottom {
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
    margin-top: auto;
    padding-bottom: 20px;
  }

  /* First div: num and image (now on top) */
  .mwg_effect031 .bottom > div:first-child {
    position: relative;
    font-size: 48px;
    width: 100%;
    margin-left: 0 !important;
    margin-top: 0 !important; /* Reset for mobile */
    margin-right: 0 !important; /* Reset for mobile */
  }

  .mwg_effect031 .bottom > div:first-child .num {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    z-index: 1;
  }

  .mwg_effect031 .bottom > div:first-child img {
    width: 100%;
    max-width: 200px;
  }

  /* Last div: text and button (now on bottom) */
  .mwg_effect031 .bottom > div:last-child {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    margin-left: 0 !important;
    margin-top: 0 !important; /* Reset for mobile */
    margin-bottom: 0;
  }

  .mwg_effect031 .slide-btn {
    margin-top: auto;
  }

  .mwg_effect031 .text {
    width: 100%;
    font-size: 20px;
    line-height: 1.6;
    padding-bottom: 0;
  }

  .mwg_effect031 .slide-btn {
    padding: 14px 24px;
    font-size: 12px;
    gap: 12px;
  }

  .mwg_effect031 .slide-btn span {
    font-size: 16px;
  }
}

/* Small Mobile (max-width: 480px) */
@media (max-width: 480px) {
  body {
    font-size: 16px;
  }

  .mwg_effect031 .slide {
    height: auto;
    min-height: 100vh;
  }

  .mwg_effect031 .content-wrapper {
    height: auto !important;
    min-height: 100vh;
  }

  .mwg_effect031 .content {
    padding: 20px 15px 50px 15px;
    justify-content: flex-start !important;
    min-height: 100vh;
    position: relative !important;
  }

  .mwg_effect031 .top p {
    font-size: 36px;
  }

  /* First div: num and image */
  .mwg_effect031 .bottom > div:first-child {
    position: relative;
    font-size: 36px;
    margin-top: 0 !important; /* Reset for small mobile */
    margin-right: 0 !important; /* Reset for small mobile */
  }

  .mwg_effect031 .bottom > div:first-child .num {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    z-index: 1;
  }

  .mwg_effect031 .bottom > div:first-child img {
    max-width: 180px;
  }

  /* Last div: text and button */
  .mwg_effect031 .bottom > div:last-child {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .mwg_effect031 .text {
    font-size: 18px;
    line-height: 1.6;
  }

  .mwg_effect031 .top svg {
    width: 30px;
    position: relative; /* Reset for small mobile */
    top: auto;
    right: auto;
  }

  .mwg_effect031 .slide-btn {
    padding: 12px 20px;
    font-size: 11px;
    gap: 10px;
  }

  .mwg_effect031 .slide-btn span {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/solopreneur/solopreneur.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,cAAc;IACd,+CAA+C;AACnD;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,gCAAgC;AACpC;AACA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,kDAAkD;AACtD;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;IAClB,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,4BAA4B,EAAE,6CAA6C;IAC3E,yBAAyB;IACzB,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,gCAAgC;IAChC,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB,EAAE,+BAA+B;IACjD,gCAAgC,EAAE,+BAA+B;IACjE,kBAAkB;IAClB,kBAAkB,EAAE,oCAAoC;AAC5D;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;;AAE3B;AACA,wBAAwB;AACxB;IACI,aAAa;AACjB;;AAEA,iEAAiE;AACjE;IACI,aAAa;IACb,mEAAmE;IACnE,uBAAuB;IACvB,SAAS;IACT,QAAQ,EAAE,kBAAkB;IAC5B,iBAAiB,EAAE,+BAA+B;IAClD,iCAAiC,EAAE,8BAA8B;AACrE;;AAEA;IACI,2BAA2B,EAAE,qCAAqC;IAClE,8CAA8C;IAC9C,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA,wDAAwD;AACxD;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gCAAgC,EAAE,+BAA+B;IACjE,kBAAkB;IAClB,gBAAgB,EAAE,gCAAgC;IAClD,QAAQ,EAAE,iBAAiB;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,aAAa;IACb,uBAAuB;IACvB,kEAAkE;IAClE,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,mFAAmF;IACnF,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,kBAAkB,EAAE,6CAA6C;IACjE,UAAU,EAAE,oBAAoB;IAChC,QAAQ;IACR,aAAa,EAAE,4BAA4B;IAC3C,kBAAkB,EAAE,2BAA2B;AACnD;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,4DAA4D;;AAE5D,yCAAyC;AACzC;EACE;IACE,cAAc;EAChB;;EAEA;IACE,QAAQ;IACR,aAAa,EAAE,qBAAqB;IACpC,eAAe,EAAE,qBAAqB;EACxC;;EAEA;IACE,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,aAAa,EAAE,qBAAqB;EACtC;;EAEA;IACE,aAAa,EAAE,qBAAqB;IACpC,cAAc,EAAE,qBAAqB;EACvC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB,EAAE,qBAAqB;IACzC,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,sCAAsC;IACtC,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,aAAa,EAAE,qBAAqB;IACpC,cAAc,EAAE,qBAAqB;EACvC;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,kBAAkB,EAAE,qBAAqB;IACzC,SAAS;IACT,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA,0CAA0C;EAC1C;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,wBAAwB,EAAE,qBAAqB;IAC/C,0BAA0B,EAAE,qBAAqB;EACnD;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA,8CAA8C;EAC9C;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,wBAAwB,EAAE,qBAAqB;IAC/C,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,sCAAsC;IACtC,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA,6BAA6B;EAC7B;IACE,kBAAkB;IAClB,eAAe;IACf,wBAAwB,EAAE,2BAA2B;IACrD,0BAA0B,EAAE,2BAA2B;EACzD;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA,8BAA8B;EAC9B;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB,EAAE,2BAA2B;IAC/C,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["body {\n    background: #121212;\n    color: #F1F1F1;\n    font: 500 normal 22px/1.3 'Satoshi', sans-serif;\n}\n.mwg_effect031 {\n    padding: 0 0 0 0;\n    position: relative;\n    overflow-x: hidden;\n    overflow-y: visible;\n    margin: 0;\n    width: 100%;\n    max-width: calc(100 * var(--vw));\n}\n.mwg_effect031 .scroll {\n    position: fixed;\n    bottom: 2rem;\n    left: 2rem;\n    z-index: 1000;\n    font-weight: 100;\n    color: #3d3c3c;\n}\n.mwg_effect031 .slide {\n    height: 100vh;\n    position: relative;\n    /* box-shadow: 3px 3px 30px rgba(0, 0, 0, 0.14); */\n}\n.mwg_effect031 .content-wrapper {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    max-width: calc(100 * var(--vw));\n    overflow-x: hidden;\n    perspective: calc(250 * var(--vw));\n}\n.mwg_effect031 .content {\n    position: absolute;\n    inset: 0;\n    transform-style: preserve-3d; /* inherits the perspective from the parent */\n    transform-origin: 50% 10%;\n    padding: 25px 50px 20px 25px;\n    display: flex;\n    flex-direction: column;\n    gap: 10vh;\n    width: 100%;\n    max-width: calc(100 * var(--vw));\n    box-sizing: border-box;\n}\n.mwg_effect031 .top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 15vh; /* Lower position for desktop */\n    margin-left: calc(4 * var(--vw)); /* Shift to right for desktop */\n    margin-bottom: 4vh;\n    position: relative; /* For absolute positioning of SVG */\n}\n.mwg_effect031 .bottom {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    \n}\n/* Hide num in desktop */\n.mwg_effect031 .num {\n    display: none;\n}\n\n/* First div: num and image (now first) - image only in desktop */\n.mwg_effect031 .bottom > div:first-child {\n    display: flex;\n    font: 500 normal calc(10.5 * var(--vw)) / 0.9 'Satoshi', sans-serif;\n    letter-spacing: -0.06em;\n    gap: 25px;\n    order: 2; /* Move to right */\n    margin-top: -10vh; /* Raise position for desktop */\n    margin-right: calc(8 * var(--vw)); /* Shift to left for desktop */\n}\n\n.mwg_effect031 .bottom img {\n    width: calc(21 * var(--vw)); /* Slightly larger size for desktop */\n    max-width: calc(calc(100 * var(--vw)) - 100px);\n    border-radius: 0.02em;\n    box-sizing: border-box;\n}\n\n/* Last div: text and button (now last) - move to left */\n.mwg_effect031 .bottom > div:last-child {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-left: calc(4 * var(--vw)); /* Shift to right for desktop */\n    margin-right: 60px;\n    margin-top: -6vh; /* Higher position for desktop */\n    order: 1; /* Move to left */\n}\n\n.mwg_effect031 .text {\n    width: calc(50 * var(--vw));\n    max-width: calc(calc(100 * var(--vw)) - 100px);\n    display: flex;\n    align-items: flex-start;\n    font: 500 normal calc(2.6 * var(--vw)) / 1.4 'Satoshi', sans-serif;\n    letter-spacing: -0.03em;\n    padding-bottom: 0;\n    box-sizing: border-box;\n}\n\n.mwg_effect031 .text-note {\n    font-size: calc(1.8 * var(--vw));\n    font-style: italic;\n    opacity: 0.9;\n}\n.mwg_effect031 .slide-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 16px;\n    padding: 18px 32px;\n    border: 1px solid currentColor;\n    background: transparent;\n    color: currentColor;\n    margin-top: 12px;\n    font-size: 14px;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    cursor: pointer;\n    font-family: inherit;\n    width: fit-content;\n}\n.mwg_effect031 .slide-btn span {\n    font-size: 18px;\n}\n.mwg_effect031 .top p {\n    font: 500 normal clamp(30px, calc(6.2 * var(--vw)), 72px) / 1 'Satoshi', sans-serif;\n    letter-spacing: -0.06em;\n    padding-top: 40px;\n}\n.mwg_effect031 .top svg {\n    width: calc(5.7 * var(--vw));\n    max-width: 100px;\n    height: auto;\n    display: block;\n    position: absolute; /* Position at top right corner for desktop */\n    top: -40px; /* Higher position */\n    right: 0;\n    margin-top: 0; /* Remove spacing from top */\n    margin-right: 20px; /* Add spacing from right */\n}\n\n.mwg_effect031 .slide:nth-child(1) .content {\n    background: #C4EF7A;\n    color: #184739;\n} \n\n.mwg_effect031 .slide:nth-child(4) .content {\n    background: #F1F1F1;\n    color: #121212;\n}\n.mwg_effect031 .slide:nth-child(2) .content,\n.mwg_effect031 .slide:nth-child(5) .content {\n    background: #DEDA8D;\n    color: #3D4331;\n}\n.mwg_effect031 .slide:nth-child(3) .content {\n    background: #71CFA3;\n    color: #184739;\n}\n\n/* ==================== MEDIA QUERIES ==================== */\n\n/* Tablet and below (max-width: 1024px) */\n@media (max-width: 1024px) {\n  .mwg_effect031 .num {\n    display: block;\n  }\n\n  .mwg_effect031 .bottom > div:first-child {\n    order: 1;\n    margin-top: 0; /* Reset for tablet */\n    margin-right: 0; /* Reset for tablet */\n  }\n\n  .mwg_effect031 .bottom > div:last-child {\n    order: 2;\n    margin-right: 0;\n    margin-left: 60px;\n    margin-top: 0; /* Reset for tablet */\n  }\n  \n  .mwg_effect031 .top {\n    margin-top: 0; /* Reset for tablet */\n    margin-left: 0; /* Reset for tablet */\n  }\n\n  .mwg_effect031 .content {\n    padding: 20px 40px 40px 20px;\n  }\n\n  .mwg_effect031 .text {\n    width: calc(40 * var(--vw));\n    font-size: calc(1.8 * var(--vw));\n  }\n\n  .mwg_effect031 .top p {\n    font-size: calc(9 * var(--vw));\n    padding-top: 30px;\n  }\n\n  .mwg_effect031 .bottom > div:last-child {\n    font-size: calc(9 * var(--vw));\n  }\n\n  .mwg_effect031 .bottom img {\n    width: calc(28 * var(--vw));\n  }\n\n  .mwg_effect031 .top svg {\n    width: calc(6.5 * var(--vw));\n    position: relative; /* Reset for tablet */\n    top: auto;\n    right: auto;\n  }\n\n  .mwg_effect031 .slide-btn {\n    padding: 16px 28px;\n    font-size: 13px;\n  }\n}\n\n/* Mobile (max-width: 768px) */\n@media (max-width: 768px) {\n  .mwg_effect031 .num {\n    display: block;\n  }\n\n  .mwg_effect031 .bottom > div:first-child {\n    order: 1;\n  }\n\n  .mwg_effect031 .bottom > div:last-child {\n    order: 2;\n    margin-right: 0;\n  }\n\n  body {\n    font-size: 18px;\n  }\n\n  .mwg_effect031 .scroll {\n    bottom: 1rem;\n    left: 1rem;\n    font-size: 14px;\n  }\n\n  .mwg_effect031 .slide {\n    height: auto;\n    min-height: 100vh;\n  }\n\n  .mwg_effect031 .content-wrapper {\n    height: auto !important;\n    min-height: 100vh;\n  }\n\n  .mwg_effect031 .content {\n    padding: 25px 20px 50px 20px;\n    justify-content: flex-start !important;\n    min-height: 100vh;\n    position: relative !important;\n  }\n\n  .mwg_effect031 .top {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n    margin-top: 0; /* Reset for mobile */\n    margin-left: 0; /* Reset for mobile */\n  }\n\n  .mwg_effect031 .top p {\n    font-size: 48px;\n    padding-top: 0;\n  }\n\n  .mwg_effect031 .top svg {\n    width: 40px;\n    position: relative; /* Reset for mobile */\n    top: auto;\n    right: auto;\n  }\n\n  .mwg_effect031 .bottom {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 30px;\n    margin-top: auto;\n    padding-bottom: 20px;\n  }\n\n  /* First div: num and image (now on top) */\n  .mwg_effect031 .bottom > div:first-child {\n    position: relative;\n    font-size: 48px;\n    width: 100%;\n    margin-left: 0 !important;\n    margin-top: 0 !important; /* Reset for mobile */\n    margin-right: 0 !important; /* Reset for mobile */\n  }\n\n  .mwg_effect031 .bottom > div:first-child .num {\n    position: absolute;\n    top: 0;\n    right: 0;\n    margin: 0;\n    z-index: 1;\n  }\n\n  .mwg_effect031 .bottom > div:first-child img {\n    width: 100%;\n    max-width: 200px;\n  }\n\n  /* Last div: text and button (now on bottom) */\n  .mwg_effect031 .bottom > div:last-child {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    width: 100%;\n    margin-left: 0 !important;\n    margin-top: 0 !important; /* Reset for mobile */\n    margin-bottom: 0;\n  }\n\n  .mwg_effect031 .slide-btn {\n    margin-top: auto;\n  }\n\n  .mwg_effect031 .text {\n    width: 100%;\n    font-size: 20px;\n    line-height: 1.6;\n    padding-bottom: 0;\n  }\n\n  .mwg_effect031 .slide-btn {\n    padding: 14px 24px;\n    font-size: 12px;\n    gap: 12px;\n  }\n\n  .mwg_effect031 .slide-btn span {\n    font-size: 16px;\n  }\n}\n\n/* Small Mobile (max-width: 480px) */\n@media (max-width: 480px) {\n  body {\n    font-size: 16px;\n  }\n\n  .mwg_effect031 .slide {\n    height: auto;\n    min-height: 100vh;\n  }\n\n  .mwg_effect031 .content-wrapper {\n    height: auto !important;\n    min-height: 100vh;\n  }\n\n  .mwg_effect031 .content {\n    padding: 20px 15px 50px 15px;\n    justify-content: flex-start !important;\n    min-height: 100vh;\n    position: relative !important;\n  }\n\n  .mwg_effect031 .top p {\n    font-size: 36px;\n  }\n\n  /* First div: num and image */\n  .mwg_effect031 .bottom > div:first-child {\n    position: relative;\n    font-size: 36px;\n    margin-top: 0 !important; /* Reset for small mobile */\n    margin-right: 0 !important; /* Reset for small mobile */\n  }\n\n  .mwg_effect031 .bottom > div:first-child .num {\n    position: absolute;\n    top: 0;\n    right: 0;\n    margin: 0;\n    z-index: 1;\n  }\n\n  .mwg_effect031 .bottom > div:first-child img {\n    max-width: 180px;\n  }\n\n  /* Last div: text and button */\n  .mwg_effect031 .bottom > div:last-child {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .mwg_effect031 .text {\n    font-size: 18px;\n    line-height: 1.6;\n  }\n\n  .mwg_effect031 .top svg {\n    width: 30px;\n    position: relative; /* Reset for small mobile */\n    top: auto;\n    right: auto;\n  }\n\n  .mwg_effect031 .slide-btn {\n    padding: 12px 20px;\n    font-size: 11px;\n    gap: 10px;\n  }\n\n  .mwg_effect031 .slide-btn span {\n    font-size: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
